$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  let event_id = $('body').attr('event_id');

  if (p === 'statistic_day_report') {
    $(document).on('click', '#download-pdf', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      const selectedDate = $('#report-date').val();

      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        type: 'GET',
        url: `/api/v1/private/day-report/download?location_id=${event_id}&type=pdf&selectedDate=${selectedDate}`,
      })
        .done(function (data) {
          if (data.success === true) {
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html('Last ned(pdf)');
            const url = `/location/${event_id}/statistic/day_report/download_pdf?selectedDate=${selectedDate}`;
            window.location.href = url;
          }
        })
        .fail(function (data) {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Last ned(pdf)');

          if (
            data.responseJSON &&
            data.responseJSON.error &&
            data.responseJSON.error.message
          ) {
            showToast({
              type: 'error',
              title: 'Error',
              message: data.responseJSON.error.message,
              position: 'top-right',
              duration: 4000,
            });
          }
        });
    });

    $(document).on('click', '#download-excel', function () {
      const selectedDate = $('#report-date').val();
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');

      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        type: 'GET',
        url: `/api/v1/private/day-report/download?location_id=${event_id}&type=excel&selectedDate=${selectedDate}`,
      })
        .done(function (data) {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Last ned(excel)');
          if (data.success && data.success === true) {
            const url = `/location/${event_id}/statistic/day_report/download_excel?selectedDate=${selectedDate}`;
            window.location.href = url;
          }
        })
        .fail(function (data) {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Last ned(excel)');
          if (
            data.responseJSON &&
            data.responseJSON.error &&
            data.responseJSON.error.message
          ) {
            showToast({
              type: 'error',
              title: 'Error',
              message: data.responseJSON.error.message,
              position: 'top-right',
              duration: 4000,
            });
          }
        });
    });
  }
});
